import { render, staticRenderFns } from "./NameType.vue?vue&type=template&id=ab0504ca&"
import script from "./NameType.vue?vue&type=script&lang=js&"
export * from "./NameType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports